import { OperationsPage } from "@onesolution/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/operations")({
	ssr: false,
	component: OperationsPage,
});
